import React, { useEffect } from "react"
import debounce from "lodash/debounce"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/pro-solid-svg-icons"

import Button from "../Buttons/Button"
import { useGlobalSearchContext } from "../../context/GlobalSearchContext"
import { MediumLoadingIndicator } from "../LoadingIndicator/LoadingIndicator"

import Menu, { MenuFactory } from "./Menu/Menu"
import Style from "./Layout.module.css"
import User from "./User/User"

interface LayoutProps {
	title: string
	menuItems: MenuFactory[]
	className: keyof typeof Style | undefined
}
const Layout: React.FC<LayoutProps> = ({
	title,
	menuItems,
	className,
	children,
}) => {
	const { openSearch } = useGlobalSearchContext()

	useEffect(() => {
		const setViewHeight = debounce(() => {
			const doc = document.documentElement
			doc.style.setProperty("--vh", `${window.innerHeight / 100}px`)
		}, 500)
		window.addEventListener("resize", setViewHeight)
		setViewHeight()

		return () => {
			window.removeEventListener("resize", setViewHeight)
		}
	}, [])

	return (
		<div className={`${className ? Style[className] : ""}`}>
			<div className={Style.layout}>
				<Menu factories={menuItems} />
				<div className={Style.wrap}>
					<header className={Style.header}>
						<div className={Style.searchWrapper}>
							<Button onClick={openSearch} appearance="default">
								<FontAwesomeIcon icon={faSearch} />
							</Button>
						</div>
						<div className={Style.title}>
							<span>{title}</span>
						</div>
						<div className={Style.userWrapper}>
							<User />
						</div>
					</header>
					<main className={Style.main}>
						<React.Suspense fallback={<MediumLoadingIndicator />}>
							{children}
						</React.Suspense>
					</main>
				</div>
			</div>
		</div>
	)
}

export default Layout
